import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const items = Array.from({ length: 8 }, (_, i) => i + 1);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-3xl px-4 py-16 md:px-6 md:py-24">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            {t('faq.title')}
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {items.map((i) => {
            const open = openIndex === i;
            return (
              <div
                key={i}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {t(`faq.q${i}`)}
                  </span>
                  <span className="flex h-5 w-5 flex-none items-center justify-center text-foreground-500">
                    <i
                      className={`text-lg leading-none ${
                        open ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">
                      {t(`faq.a${i}`)}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}